import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';

// images
import accessDenied from '../../assets/images/AccessDenied.png';

const AccessDenied = ({ offBtnReturnToDash = true, title="شما مجوز مشاهده و استفاده از این صفحه را ندارید " }: any) => {
    return (
        <div className="account-pages mt-5 mb-5">
            <Container>
                <Row className="justify-content-center">
                    <Col xl={3} lg={3} xs={4}>
                        <div className="text-center mt-4">
                            <div>
                                <img src={accessDenied} alt="" className="img-fluid" />
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} className="text-center">
                        {/* <h3 className="mt-3">We couldn’t connect the dots</h3> */}
                        <span style={{fontWeight:500}}>عدم دسترسی</span>
                        <p className="text-muted mb-4 mt-2">                                                      
                            {title}                      </p>
                        {offBtnReturnToDash &&
                            <Link to="/" className="btn btn-lg btn-primary">
                                بازگشت به صفحه داشبورد
                            </Link>
                        }

                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AccessDenied;
